import { api } from '@src/api/api'
import { PointsType, ProfileType } from '@src/types/user'
import moment from 'moment'

export const userApi = {
  getMe() {
    return api.get('/v1/auth/me')
  },
  myPoints() {
    return api.get<PointsType>('/v1/bonuses/get-bonuses')
  },
  myPurchases(dateStart: string, dateEnd: string, page: number) {
    return api.get('v1/bonuses/purchases', { page, dateStart, dateEnd })
  },
  myChips() {
    return {
      electronicChips: 666666,
    }
    // return api.get<ChipsType>('v1/user/my-points')
  },
  myProductGroup() {
    return [
      {
        id: 11,
        title: 'Овощи',
        isActive: true,
      },
      {
        id: 222,
        title: 'Фрукты',
        isActive: true,
      },
      {
        id: 333,
        title: 'Крупы',
        isActive: true,
      },
      {
        id: 4444,
        title: 'Крысы',
        isActive: false,
      },
    ]
    // return api.get<ChipsType>('v1/user/product-group')
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeProductGroup(id: number) {
    return true
    // return api.post('/v1/user/product-group', { id })
  },
  profile() {
    return api.get<ProfileType>('/v1/user/profile')
  },
  deleteUser() {
    return api.post('/v1/user/delete-profile')
  },
  /// /////Личные данные
  setNewValueField(nameField: string, value: string) {
    if (nameField === 'birthday') {
      // Преобразуем дату из дд-мм-гггг в гггг-мм-дд
      const formattedValue = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD')
      return api.post('/v1/user/update-profile', { [nameField]: formattedValue })
    }
    return api.post('/v1/user/update-profile', { [nameField]: value })
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changePassword(password: string) {
    return api.post('/v1/user/change-password', { password })
  },
}
